import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./aramark_activate_menu_section_source.js";
//#region src/aramark_activate_menu_section_source_helper.ts
var aramark_activate_menu_section_source_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(menuSectionSource) {
	switch (menuSectionSource) {
		case "family-group": return "Family Groups";
		case "slus": return "SLUs";
		case "both": return "Family Groups and SLUs";
	}
}
//#endregion
export { aramark_activate_menu_section_source_helper_exports, name };

//# sourceMappingURL=aramark_activate_menu_section_source_helper.js.map